import './css/Login.css';

import {
  IonCol,
  IonContent,
  IonImg,
  IonPage,
  IonRow,
  IonText,
} from '@ionic/react';

import VStack from '../../components/VStack';
import { AuthUser } from '../../models/User';
import VersionFooter from './VersionFooter';
import SignInButtons from './SignInButtons';
import Trans from 'util/Trans';
import { useTranslation } from 'react-i18next';

interface LoginPageProps {
  onLogIn?: (user: AuthUser, isNew: boolean) => void;
}

const LoginPage = ({ onLogIn }: LoginPageProps) => {
  return (
    <IonPage>
      <IonContent forceOverscroll={false} id="loginScreen" fullscreen>
        <VStack className="ion-justify-content-between notchSafe ion-padding">
          <IonRow className="ion-justify-content-center">
            <IonCol 
              className="animate__animated animate__fadeInDown animate__faster ion-padding"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <IonImg
                src={'/assets/spinnax_logo_white@2x.png'}
                style={{ maxWidth: '400px', width: '100%' }}
              />
            </IonCol>
          </IonRow>
          <SignInButtons onLogIn={onLogIn} />

          <VStack
            style={{ height: 'fit-content', gap: '8px' }}
            className="ion-align-items-center"
          >
            <IonText color="light" className="ion-text-center">
              <Trans i18nKey="PRIVACY_EXPLANATION">
                Durch die Anmeldung stimmst du unseren Nutzungs- und
                Datenschutzbedingungen zu, die du{' '}
                <Trans i18nKey="PRIVACY_POLICY_LINK">
                  <a
                    style={{ color: 'var(--ion-color-base)' }}
                    href="https://spinnax.com/en/legal_freak"
                  >
                    hier nachlesen kannst
                  </a>
                </Trans>
                .
              </Trans>
            </IonText>
            <VersionFooter />
          </VStack>
        </VStack>
      </IonContent>
    </IonPage>
  );
};

export default LoginPage;
